import request from '@/utils/request'
export default {
    // 获取用户信息
    getUserInfo(user_id) {
        return request({
            url: `/zikao-system/student/detail/${user_id}`,
            method: 'get'
        })
    },
    // 登出
    logout() {
        return request({
            url: `/auth/logout`,
            method: 'delete'
        })
    }
}